(function() {
  'use strict';

  var DESKTOP_BREAKPOINT = 1008;

  function init() {
    var productRedesign = document.querySelector('.Product--redesign');
    if (!productRedesign) return;

    var pageIndicatorLeft = document.querySelector('.Gallery__PageIndicator--left');
    var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    var isIndicatorHidden = false;

    function handleScroll() {
      if (!isDesktop) return;

      // Hide page indicator (mobile counter) on scroll
      if (pageIndicatorLeft) {
        var shouldHide = window.scrollY > 50;
        if (shouldHide && !isIndicatorHidden) {
          isIndicatorHidden = true;
          pageIndicatorLeft.classList.add('is-hidden');
        } else if (!shouldHide && isIndicatorHidden) {
          isIndicatorHidden = false;
          pageIndicatorLeft.classList.remove('is-hidden');
        }
      }
    }

    function handleResize() {
      isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
    }

    function setup() {
      window.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleResize, { passive: true });
      handleScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  }

  init();
})();
